import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { configuration, getUserDictionary } from '@/pages/admins/users/api'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'

export const fetchConfigurationAsync = createAsyncThunk(
  'Users/configuration',
  () =>
    axios
      .post(configuration('Admin'))
      .then((response) => {
        console.log(response, 'response')
        let data = { ...response.data }
        if (data.currentEmployee) {
          data.currentEmployee.salesManId =
            data.currentEmployee.id || '00000000-0000-0000-0000-000000000000'
        } else {
          data.currentEmployee = {}
          data.currentEmployee.salesManId =
            '00000000-0000-0000-0000-000000000000'
        }
        if (data.currentUser.roles.includes('admin')) {
          data.currentEmployee.salesManId = undefined
        }
        if (data.menuTrees.length == 1) {
          data.menuTrees = data.menuTrees[0].children
        }
        return data
      })
      .catch(() => {
        throw Error('读取当前用户数据缓存失败')
      })
)

const userDictionaryCacheKey = 'cache-user-dictionary'
const userDictionaryCache = getLocalStorage(userDictionaryCacheKey)

export const fetchGetUserDictionaryAsync = createAsyncThunk(
  'Users/getUserDictionary',
  () =>
    axios
      .get(getUserDictionary(userDictionaryCache?.version ?? ''))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (
          resp.data === null &&
          resp.version === userDictionaryCache?.version
        ) {
          return userDictionaryCache?.data ?? []
        }
        setLocalStorage(userDictionaryCacheKey, resp)
        return resp.data ?? []
      })
)

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userDict: {},
    configuration: {},
  },
  reducers: {
    setUserDict(state, action) {
      state.userDict = action.payload
    },
    setConfiguration(state, action) {
      state.configuration = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetUserDictionaryAsync.pending, (state) => {
        state.userDict = {}
      })
      .addCase(fetchGetUserDictionaryAsync.fulfilled, (state, action) => {
        state.userDict = action.payload
      })
      .addCase(fetchConfigurationAsync.pending, (state) => {
        state.configuration = {}
      })
      .addCase(fetchConfigurationAsync.fulfilled, (state, action) => {
        state.configuration = action.payload
      })
  },
})

export const { setUserDict, setConfiguration } = userSlice.actions
export const getUserDict = (state) => state.user.userDict
export const getConfiguration = (state) => state.user.configuration
export const getCurrentEmployee = (state) =>
  state.user.configuration?.currentEmployee
export const getCurrentUser = (state) => state.user.configuration?.currentUser

export default userSlice.reducer
